import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';

interface DownloadTemplateProps {
  content: string[];
  filename?: string;
  title?: string;
}

const DownloadTemplateLink: React.FC<DownloadTemplateProps> = ({ content, filename = 'download.txt', title = 'Download', ...rest }) => {
  const [downloadLink, setDownloadLink] = useState('');

  useEffect(() => {
    const data = new Blob([content.join('\n')], { type: 'text/plain' });
    if (downloadLink !== '') {
      window.URL.revokeObjectURL(downloadLink);
    }
    setDownloadLink(window.URL.createObjectURL(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  return (
    <Button size="medium" component={Link} download={filename} variant="text" href={downloadLink} {...rest}>
      {title}
    </Button>
  );
};

export default DownloadTemplateLink;
